/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { notificationConditionTypeEnumSchema } from "../notificationConditionTypeEnumSchema.ts";
import { notificationModelPagedResultSchema } from "../notificationModelPagedResultSchema.ts";
import { notificationStatusEnumSchema } from "../notificationStatusEnumSchema.ts";
import { z } from "zod";

export const getApiNotificationsQueryParamsSchema = z.object({
    "Conditions": z.array(z.lazy(() => notificationConditionTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Instant</b>: Моментально всем</li>\n<li><b>2 - AtTime</b>: В указанное время</li>\n</ul>\n")).describe("Фильтр по условиям отправки").optional(),
"Status": z.lazy(() => notificationStatusEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - Planned</b>: Запланировано</li>\n<li><b>1 - Sent</b>: Отправлено</li>\n<li><b>2 - Error</b>: Ошибка</li>\n</ul>\n").optional(),
"SortByName": z.boolean().describe("Сортировка по наименованию").optional(),
"SortByNameDesc": z.boolean().describe("Сортировка по наименованию с конца").optional(),
"SortByStatus": z.boolean().describe("Сортировка по статусу").optional(),
"SortByStatusDesc": z.boolean().describe("Сортировка по статусу с конца").optional(),
"SortByDate": z.boolean().describe("Сортировка по дате последней отправки").optional(),
"SortByDateDesc": z.boolean().describe("Сортировка по дате последней отправки с конца").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список уведомлений
 */
export const getApiNotifications200Schema = z.lazy(() => notificationModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiNotifications400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiNotifications401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiNotifications403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiNotifications500Schema = z.lazy(() => badResponseModelSchema)

export const getApiNotificationsQueryResponseSchema = z.lazy(() => getApiNotifications200Schema)